import DocumentIcon from "../../icon-components/DocumentIcon";
import PlayButtonIcon from "../../icon-components/PlayButtonIcon";
import URLIcon from "../../icon-components/URLIcon";

interface EducationContentIconsProps {
  type: string;
  height?: number | string;
  width?: number | string;
  color?: string;
}
const EducationContentIcons = ({
  type,
  height,
  width,
  color,
}: EducationContentIconsProps) => {
  if (!type) {
    return null;
  }
  switch (type) {
    case "videos":
      return <PlayButtonIcon height={height} width={width} fill={color} />;
    case "articles":
      return <DocumentIcon height={height} width={width} fill={color} />;
    case "URL":
      return <URLIcon height={height} width={width} color={color} />;
    default:
      return null;
  }
};

export default EducationContentIcons;

